type EntityWithTermsAndConditions = {
  termsAndConditions?: string;
  id: string;
};

export const constructTermsAndConditionsUrl = (
  context: {
    event?: EntityWithTermsAndConditions;
    membership?: EntityWithTermsAndConditions;
    point?: EntityWithTermsAndConditions;
  } = {}
): string | undefined => {
  const { event, membership, point } = context ?? {};

  if (event?.termsAndConditions?.trim().length > 0) {
    return `/events/${event.id}/terms-and-conditions`;
  }
  if (membership?.termsAndConditions?.trim().length > 0) {
    return `/memberships/${membership.id}/terms-and-conditions`;
  }

  if (point?.termsAndConditions?.trim().length > 0) {
    return `/packages/terms-and-conditions`;
  }

  return `/terms-and-conditions`;
};

export const constructTermsAndConditionsUrlFromPath = (
  path = ""
): string => {
  const parts = path.split("/").filter(Boolean);
  const [entityType, id] = parts;

  if (entityType === "events" && id) {
    return `/events/${id}/terms-and-conditions`;
  }
  if (entityType === "memberships" && id) {
    return `/memberships/${id}/terms-and-conditions`;
  }
  if (entityType === "packages") {
    return `/packages/terms-and-conditions`;
  }

  return `/terms-and-conditions`;
};
